import "core/core.app.js";
import router from "authentication/authentication.router.js";
import UserAuthenticationSettingsPage from "authentication/pages/UserAuthenticationSettingsPage.vue";
import { attachErrorHandlers } from "core/js/error-logging.ts";
import { pinia } from "core/js/register-pinia.ts";
import { createApp } from "vue";
import Whitelist from "./components/ipwhitelist/IpWhitelist.vue";
import LoginPage from "./components/login/page/LoginPage.vue";
import SamlSettings from "./components/sso/SamlSettings.vue";
import myDetailsPage from "authentication/pages/mydetails/MyDetailsPage.vue";

// Import stylesheets
import "./scss/authentication.scss";

if (document.getElementById("authentication-app")) {
  const authenticationVueComponent = createApp({
    components: {
      "whitelist": Whitelist,
      "saml-settings": SamlSettings,
      "login-page": LoginPage,
      "user-authentication-settings": UserAuthenticationSettingsPage,
      "my-details-page": myDetailsPage,
    },
  });

  authenticationVueComponent.use(pinia);
  authenticationVueComponent.use(router);
  authenticationVueComponent.mount("#authentication-app");

  attachErrorHandlers(authenticationVueComponent);
}
